import React, { useEffect, useState } from 'react';
import './App.css';
import MapplsMap from './Component/MapplsMap';
import { generateMapToken, getService } from './Network/APIService';
import { Mqtt } from './Network/mqtt';
import EndUserStatusScreen from './Screens/EndUserStatusScreen';
import Routers from './Component/Routers';

function App() {

  return (
    <div className="App">
      <header className="App-header">
            <Routers/>
      </header>
    </div>
  );
}

export default App;
